<template>
  <cube-page :title="title">
    <div slot="content" class="content">
      <wmq-layout
        ref="city"
        :rootLayoutConfig="rootLayoutConfig" />
    </div>
  </cube-page>
</template>

<script>

import uiConfig from '@/config/ui-config/product-cover-by-city-ui-config'
import { biData } from '@/api/cube'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { get, set } from 'lodash'
import CubePage from '../../components/cube-page'
export default {
  name: 'ProductCoverByCity',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data() {
    return {
    }
  },
  mounted() {
    this.$refs['city'].refreshAll()
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        reqObj.channelType = that.$route.query.channelType
        reqObj.month = that.$route.query.month
        if (
          (that.$route.query.province === '北京市') |
                    (that.$route.query.province === '天津市') |
                    (that.$route.query.province === '上海市') |
                    (that.$route.query.province === '重庆市')
        ) {
          data.dataCode = 'productsCoverByCrownCity'
          reqObj.city = that.$route.query.province
          delete reqObj.province
        } else {
          data.dataCode = 'productsCoverByCity'
          reqObj.province = that.$route.query.province
          delete reqObj.city
        }
        reqObj.productBrand = that.$route.query.productBrand
        return biData(data.dataCode, reqObj).then(res => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  },
  computed: {
    title() {
      return get(this.$route, 'query.title', '') + '覆盖'
    },
    rootLayoutConfig () {
      const height = document.body.clientHeight - 100
      console.log('height', height)
      set(uiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return uiConfig
    }
  }
}
</script>

<style scoped>
.content{
  margin-top: 15px;
  }
</style>
